module.exports = __webpack_public_path__ + "static/media/wd.e78b0eae.svg";